angular.module('bribac', [
  'ngRoute',
  'ngAnimate',
  'naif.base64',
  'bribac.interceptors.offlineStatusText',
  'bribac.interceptors.apiAuth',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.views.404',
  'bribac.views.add',
  'bribac.views.addAgent',
  'bribac.views.addGroup',
  'bribac.views.addIbac',
  'bribac.views.addOrganization',
  'bribac.views.addRuleSet',
  'bribac.views.addSchedule',
  'bribac.views.addSubject',
  'bribac.views.addInsuranceProvider',
  'bribac.views.addInsuranceSubscriber',
  'bribac.views.addInsuranceCompany',
  'bribac.views.editAgent',
  'bribac.views.editMainGroup',
  'bribac.views.editOrganization',
  'bribac.views.editRuleSet',
  'bribac.views.editSchedule',
  'bribac.views.editSchedulePeriod',
  'bribac.views.editSubGroup',
  'bribac.views.editSubject',
  'bribac.views.editIbac',
  'bribac.views.forgotPassword',
  'bribac.views.home',
  'bribac.views.listAgents',
  'bribac.views.listAlerts',
  'bribac.views.listOrganizations',
  'bribac.views.listRuleSets',
  'bribac.views.listSchedules',
  'bribac.views.listSubjects',
  'bribac.views.listIbacs',
  'bribac.views.login',
  'bribac.views.reports',
  'bribac.views.setPassword',
  'bribac.views.search',
  'bribac.views.singleAgent',
  'bribac.views.singleIbac',
  'bribac.views.singleMainGroup',
  'bribac.views.singleOrganization',
  'bribac.views.singleRuleSet',
  'bribac.views.singleSchedule',
  'bribac.views.singleSubGroup',
  'bribac.views.singleSubject',
  'bribac.views.templates',
  'bribac.components.subjectUpload',
  'bribac.views.uploadSubjects',
  'bribac.components.appLayout',
  'btorfs.multiselect'
])

  .run(function(
    $rootScope,
    $location,
    $window,
    $log,
    routeAuth
  ) {

    /*
      Handle routing errors.
    */

    $rootScope.$on('$routeChangeError', function(event, current, previous, rejection) {
      switch (rejection) {
        case routeAuth.UNAUTHORIZED:
          // TODO: Save rejected path so we can redirect to it after login, maybe in login path query param?.
          // TODO: Maybe use replace instead so the user can use the browser back button?
          $location.path('/login')
          break

        case routeAuth.AUTHORIZED:
          $location.path('/').replace()
          break

        case routeAuth.FORBIDDEN:
          // Because $location sets the new path before the $routeChangeError
          // event is triggered we can't prevent the path from being changed
          // when the user isn't allowed to access the path, so we'll have to
          // undo the path change or redirect if we have no previous path.
          // TODO: Maybe we should show a 'forbidden' error page instead?
          //
          // https://github.com/angular/angular.js/issues/2100

          // TODO: Show an app-wide 'access forbidden' message.
          if (previous) {
            $window.history.back()
          } else {
            $location.path('/').replace()
          }
          break

        default:
          $log.warn('Unhandled $routeChangeError event. Rejection: ' + rejection)
      }
    })
  })
